import { f as filterProps } from './utils-BY-09i56.js';
import { a as IntlFormatError } from './error-CYfjzX8v.js';
import { F as FormatError, E as ErrorCode } from '../../../../intl-messageformat/lib/src/error-CJ6vQ_25.js';

var DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay',
];
function formatDisplayName(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) {
        onError(new FormatError("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", ErrorCode.MISSING_INTL_API));
    }
    var filteredOptions = filterProps(options, DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    }
    catch (e) {
        onError(new IntlFormatError('Error formatting display name.', locale, e));
    }
}

export { formatDisplayName as f };
//# sourceMappingURL=displayName-PjCsZfyi.js.map
